import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { switchMap, map, catchError } from 'rxjs/operators'
import { EventService } from 'src/app/services/event.service'
import { loadEventsSuccess, loadEventsFailure } from 'src/app/actions/event.actions'
import { refreshData } from 'src/app/actions/criteria.actions'

@Injectable()
export class EventEffects {
  loadEvents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshData),
      switchMap(action =>
        this.eventService.findEvents(action.artistId, action.from, action.to).pipe(
          map(events => loadEventsSuccess({ events })),
          catchError(error => of(loadEventsFailure({ error })))
        )
      )
    )
  )

  constructor(private actions$: Actions, private eventService: EventService) {}
}
